(function () {
  if (window.__zeyaCartTrackingInstalled) return;
  window.__zeyaCartTrackingInstalled = true;
  var originalFetch = window.fetch;

  function marketingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !privacy || typeof privacy.marketingAllowed !== 'function' || privacy.marketingAllowed();
  }

  async function recordAddition(response) {
    try {
      if (!marketingAllowed()) return;
      var added = await response.clone().json();
      if (added.status >= 400 || added.errors) return;
      var addedItems = added.items || [added];
      if (!addedItems.length || !addedItems[0].id) return;
      var cart;
      try {
        var cartResponse = await originalFetch.call(window, window.Shopify.routes.root + 'cart.js');
        if (cartResponse.ok) cart = await cartResponse.json();
      } catch (_) { /* An analytics snapshot must not interrupt the cart. */ }
      var first = addedItems[0];
      var addedValue = addedItems.reduce(function (sum, entry) { return sum + entry.price * entry.quantity; }, 0) / 100;
      if (!marketingAllowed()) return;
      window._learnq = window._learnq || [];
      window._learnq.push(['track', 'Added to Cart', {
        $value: cart ? cart.total_price / 100 : addedValue,
        total_price: cart ? cart.total_price / 100 : addedValue,
        total_discount: cart ? cart.total_discount / 100 : 0,
        original_total_price: cart ? cart.original_total_price / 100 : addedValue,
        Currency: cart ? cart.currency : window.Shopify.currency && window.Shopify.currency.active,
        items: cart ? cart.items : addedItems,
        AddedItems: addedItems,
        Name: first.product_title || first.title,
        ProductID: first.product_id,
        VariantID: first.variant_id || first.id,
        Quantity: first.quantity,
        ItemPrice: first.price / 100,
        Brand: first.vendor,
        ImageURL: first.image,
        URL: first.url
      }]);
    } catch (_) { /* Tracking failures must not affect a successful addition. */ }
  }

  window.fetch = function (input, options) {
    var isAddition = false;
    try {
      var url = new URL(typeof input === 'string' ? input : input.url || String(input), window.location.href);
      var method = (options && options.method) || input.method || 'GET';
      isAddition = method.toUpperCase() === 'POST' && url.origin === window.location.origin && /\/cart\/add\.js$/.test(url.pathname);
    } catch (_) { /* Let the original fetch handle invalid input. */ }
    return originalFetch.apply(this, arguments).then(function (response) {
      if (isAddition && response.ok) recordAddition(response);
      return response;
    });
  };
})();
